import { Box, Paper, Typography } from "@mui/material";
import "react-quill/dist/quill.snow.css";
import SvgIcon from "./assessment-detail-icon.svg?react";
import i18n from "../../i18n";

export default function InstructionView({
	instruction,
	title,
	data,
}: {
	instruction: string;
	title: string;
	data: Record<string, string>;
}) {
	return (
		<Paper
			sx={{
				bgcolor: "#E6F5F9",
				borderRadius: "20px",
				boxShadow: "0px 2.64px 5.93px 0px rgba(0, 0, 0, 0.1)",
				height: "100%",
			}}
		>
			<Box justifyContent="center" display="flex" alignItems="center" sx={{ height: 70 }}>
				<SvgIcon style={{ marginTop: 67 }} />
			</Box>
			<Box
				sx={{
					p: 2,
					bgcolor: "white",
					border: "0.33px solid #B3B3B3",
					borderBottomLeftRadius: "inherit",
					borderBottomRightRadius: "inherit",
					height: "calc(100% - 70px)",
				}}
			>
				<Box sx={{ mt: 2, height: "calc(100% - 40px)", overflow: "auto" }}>
					<Typography align="center" variant="h5" fontWeight="bold" color="#352158">
						{i18n.t("standalone.assessmentDetails", { title })}
					</Typography>
					<Box sx={{ mt: 2 }}>
						<div
							className="ql-editor"
							ref={(el) => {
								if (el) {
									el.innerHTML = instruction;
									el.querySelectorAll("[substitution-tag]").forEach((tag) => {
										tag.removeAttribute("style");
										tag.innerHTML = data[tag.getAttribute("substitution-tag") || ""] || "";
									});
								}
							}}
						/>
					</Box>
				</Box>
			</Box>
		</Paper>
	);
}
